import { render, staticRenderFns } from "./view-account-permissions.vue?vue&type=template&id=46ec500d&scoped=true"
import script from "./view-account-permissions.js?vue&type=script&lang=js&external"
export * from "./view-account-permissions.js?vue&type=script&lang=js&external"
import style0 from "./view-account-permissions.vue?vue&type=style&index=0&id=46ec500d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ec500d",
  null
  
)

export default component.exports